import generateIcon from "../generateIcon";

const ChervonRight = generateIcon("fas fa-chevron-circle-right");

export default ChervonRight;